// src/components/BlockedPeriodsCalendar.js

import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { Calendar } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import "react-multi-date-picker/styles/colors/green.css";
import PropTypes from 'prop-types';

const CalendarWrapper = styled(Box)(({ theme }) => ({
    '& .rmdp-wrapper': {
        fontFamily: 'Filson Soft, Arial, sans-serif',
        boxShadow: '0 3px 5px 2px rgba(0, 0, 0, .1)',
        borderRadius: '8px',
    },
    '& .rmdp-header': {
        backgroundColor: '#ffffff',
        borderBottom: 'none',
        padding: '0.5rem 0',
    },
    '& .rmdp-day.selected': {
        backgroundColor: '#4CAF50',
        color: 'white',
    },
    '& .rmdp-day.range': {
        backgroundColor: '#4CAF50',
        color: 'white',
    },
    '& .rmdp-day.in-range:hover': {
        backgroundColor: '#45a049',
        color: 'white',
    },
    '& .rmdp-day.today': {
        border: '1px solid #4CAF50',
    },
    '& .rmdp-week-day': {
        color: '#4CAF50',
    },
    '& .rmdp-day.disabled': {
        color: '#ccc',
        pointerEvents: 'none',
        opacity: 0.5,
    },
    '& .rmdp-day.outside': {
        color: '#000',
        opacity: 1,
    },
    '& .rmdp-panel-body li .b-date': {
        backgroundColor: '#4CAF50',
        border: 'none',
    },
    '& .rmdp-panel-body li button': {
        color: '#fff',
        cursor: 'pointer',
    },
    '& .rmdp-panel-body li .b-deselect': {
        backgroundColor: '#4CAF50',
        border: 'none',
        fontSize: '17px',
    },
    '& .rmdp-date-panel': {
        fontFamily: 'Filson Soft, Arial, sans-serif',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0 3px 5px 2px rgba(0, 0, 0, .1)',
    },
    '& .rmdp-date': {
        backgroundColor: '#4CAF50',
        color: 'white',
    },
    '& .rmdp-range': {
        backgroundColor: '#4CAF50',
        color: 'white',
    },
    '& .rmdp-clear-button': {
        backgroundColor: '#4CAF50',
        color: 'white',
    },
}));

const BlockedPeriodsCalendar = ({ blockedPeriods, setBlockedPeriods }) => {
    return (
        <CalendarWrapper>
            <Calendar
                value={blockedPeriods}
                onChange={setBlockedPeriods}
                multiple
                range
                plugins={[
                    <DatePanel position="bottom" header='Unavailable Dates' />
                ]}
                minDate={new Date()}
                autoFocus={false}
                highlightToday={false}
                open={true}
                inline
            />
        </CalendarWrapper>
    );
};

BlockedPeriodsCalendar.propTypes = {
    blockedPeriods: PropTypes.arrayOf(
        PropTypes.arrayOf(PropTypes.instanceOf(Date))
    ).isRequired,
    setBlockedPeriods: PropTypes.func.isRequired,
};

export default BlockedPeriodsCalendar;
